<template>
  <div :class="$style.layout">
    <Header />
    <div :class="$style.main">
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@components/Header.vue";
import Footer from "@components/Footer.vue";

export default {
  name: "Domain",
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="scss" module scoped>
.layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .main {
    flex: 1;
    padding-top: rem(80);
  }
}
</style>
